var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.promotions.length
    ? _c(
        "section",
        { attrs: { id: "section-promotions" } },
        [
          _c(
            _setup.SectionPromotions,
            _vm._b(
              {},
              "SectionPromotions",
              { promotions: _setup.promotions },
              false
            )
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }